export default __webpack_public_path__ + "images/favicon.13b5db4941fd67edcc72.ico";